<div
  #container
  class="drop-area"
  appDropFile
  [allowedTypes]="allowedTypes"
  (click)="openChoosingFileDialog()"
  (onFileDropped)="onFileDropped.emit($event)"
  (onError)="onError.emit($event)"
>
  <ng-content></ng-content>
  <input
    #fileInput
    [accept]="allowedTypes.join(',')"
    type="file"
    style="display: none"
    (change)="selectFile($event)"
  />
</div>
